import React from "react";

export default function BreakdownFinanceLabel({ status, data }) {
  const isUnlimited = data
    ? data[`${status.toLowerCase()}_overall_max`] === "9999999.99" || data[`${status.toLowerCase()}_overall_max`] >= 9000000
    : "-";

  const breakdownsItems = [
    { key: "overall_max", label: "Overall Max", value: data ? data[`${status.toLowerCase()}_overall_max`] : "-" },
    { key: "coverage_percentage", label: "Coverage Percentage", value: data ? data[`${status.toLowerCase()}_percentage`] : "-" },
    { key: "benefits_remaining", label: "Remaining Benefits", value: data ? data[`${status.toLowerCase()}_benefits_remaining`] : "-" },
  ];

  // Other categories sharing this category's max pool (tolerant match because
  // this legacy card uses status="Orthodontic" vs the "Orthodontics" category).
  const sharesMaxWith = (() => {
    const groups = (data && data.category_shared_max_groups) || [];
    const c = String(status || "").toLowerCase();
    const same = (x) => {
      const xl = String(x).toLowerCase();
      return xl === c || xl.startsWith(c) || c.startsWith(xl);
    };
    for (const g of groups) {
      if (Array.isArray(g) && g.some(same)) return g.filter((x) => !same(x));
    }
    return [];
  })();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        background: "rgba(223, 218, 255, 0.7)",
        borderRadius: 8,
        paddingInline: 20,
        paddingTop: 20,
        paddingBottom: 20,
      }}
      className="breakdown-label"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          fontSize: 20,
          fontWeight: 400,
          color: "#4D3280",
          marginBottom: 15,
        }}
      >
        {status}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 10, width: "100%" }}>
        {breakdownsItems.map((item) => (
          <BreakdownFinanceLabelItem key={item.label} label={item.label} field={item.value} isUnlimited={isUnlimited} />
        ))}
      </div>

      {sharesMaxWith.length > 0 && (
        <div style={{ fontSize: 12, color: "#6b5fa8", marginTop: 12 }}>
          Shares annual max with: {sharesMaxWith.join(", ")}
        </div>
      )}
    </div>
  );
}

function BreakdownFinanceLabelItem({ label, field, isUnlimited }) {
  const formattedField = field
    ? label === "Remaining Benefits" && isUnlimited
      ? "-"
      : field === "9999999.99" || field >= 9000000
      ? label === "Overall Max"
        ? "Unlimited"
        : label === "Remaining Benefits"
        ? "-"
        : field
      : label === "Coverage Percentage"
      ? `${field}%`
      : `$${field}`
    : "-";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderRadius: 5,
        fontSize: 14,
        padding: "10px 20px",
        backgroundColor: "#cfc2f3",
        color: "#403280",
        fontWeight: 600,
        textTransform: "capitalize",
        width: "100%",
      }}
    >
      {label} <span>{formattedField}</span>
    </div>
  );
}
